import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CatalogoSourvenirRequest } from 'src/app/modal/catalogo/catalogo-sourvenir-request';
import { CatalogoSourvenirResponse } from 'src/app/modal/catalogo/catalogo-sourvenir-response';
import { SourvenirDetalleResponse } from 'src/app/modal/sourvenir/sourvenir-detalle-response';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';

@Component({
  selector: 'app-merchandising',
  templateUrl: './merchandising.component.html',
  styleUrls: ['./merchandising.component.scss']
})
export class MerchandisingComponent implements OnInit {
  detalleSourvenir:SourvenirDetalleResponse = new SourvenirDetalleResponse();
  sizeID:String="0";
  flgAgregar:string = "0";

  listItem=[
    {id:'1',titulo:'Lorem Ipsum is simply dummy text',descripcion:'Lorem Ipsum is simply dummy text of the printing and typestting industry lorem ipsum has been the',precio:'S/. 36.62',imagen:'/assets/image/body/merchandising/f1.png'},
    {id:'2',titulo:'Lorem Ipsum is simply dummy text',descripcion:'Lorem Ipsum is simply dummy text of the printing and typestting industry lorem ipsum has been the',precio:'S/. 68.50',imagen:'/assets/image/body/merchandising/f2.png'},
    {id:'3',titulo:'Lorem Ipsum is simply dummy text',descripcion:'Lorem Ipsum is simply dummy text of the printing and typestting industry lorem ipsum has been the',precio:'S/. 27.80',imagen:'/assets/image/body/merchandising/f3.png'},
    {id:'4',titulo:'Lorem Ipsum is simply dummy text',descripcion:'Lorem Ipsum is simply dummy text of the printing and typestting industry lorem ipsum has been the',precio:'S/. 56.50',imagen:'/assets/image/body/merchandising/f4.png'},
    {id:'5',titulo:'Lorem Ipsum is simply dummy text',descripcion:'Lorem Ipsum is simply dummy text of the printing and typestting industry lorem ipsum has been the',precio:'S/. 85.00',imagen:'/assets/image/body/merchandising/f5.png'},
    {id:'6',titulo:'Lorem Ipsum is simply dummy text',descripcion:'Lorem Ipsum is simply dummy text of the printing and typestting industry lorem ipsum has been the',precio:'S/. 74.00',imagen:'/assets/image/body/merchandising/f6.png'},

  ]
  listMerchadising:CatalogoSourvenirResponse;
  constructor(private novedadesService:NovedadesService,private usuarioService:UsuarioService,
    private carritoService:CarritoService,private utilitarioService:UtilitarioService,private router:Router
    ) { }

  obtenerMerchadising(){
    let catalogoSourvenirRequest:CatalogoSourvenirRequest = new CatalogoSourvenirRequest();
    this.listMerchadising = new CatalogoSourvenirResponse();
    catalogoSourvenirRequest.groupId="0";
    catalogoSourvenirRequest.page="0";
    catalogoSourvenirRequest.size="0";
    catalogoSourvenirRequest.submenuId="2";
    catalogoSourvenirRequest.topicId="0";
    this.novedadesService.buscarCatalogoSourvenir(catalogoSourvenirRequest).subscribe(data=>{
      // console.log("data",data);
      if(data.response.codeResponse=="0000"){
        this.listMerchadising = data;
      }

    })
  }

  onComprar(id){
    if(this.usuarioService.obtenerSesionUsuario()){
    let idLibro = id;
    let cantidad = "1";
    let tipoProducto = "2";
    let sizeID = this.sizeID;
    let libroArray = {};
    
    this.carritoService.obtenerCantidadCarrito();
    // if(this.detalleSourvenir.response.list[0].size.length>0){
    //   if(this.sizeID=="0"){
    //     this.utilitarioService.toastrInfo("Seleccione una talla");
    //     return false;
    //   }      
    // }
    libroArray ={id:idLibro,cantidad:cantidad,tipoProducto:tipoProducto,sizeID:sizeID};
      //si agrega y limpio el carrito
      if((this.flgAgregar == "1") && ( this.carritoService.cantidadCarrito == 0)){
        this.carritoService.obtenerCantidadCarrito();
        this.carritoService.agregarCarrito(libroArray);
        this.router.navigate(['/procesarpago']);
        return;
      }
      //si no agrega, adiciona automaticamente al carrito
      if(this.flgAgregar == "0"){
      this.carritoService.obtenerCantidadCarrito();
      this.carritoService.agregarCarrito(libroArray);
      this.router.navigate(['/procesarpago']);
      return;
      }
      //si flag es 1 y no entra en las 2 condiciiones anteriores
      this.router.navigate(['/procesarpago']);
    }
    else{
      this.utilitarioService.toastrWarning("Necesita iniciar sesión")
    }
  }  


  ngOnInit(): void {
    this.obtenerMerchadising();

  }

}
